export default {"src":"/_next/static/media/IDFlag.3c865012.svg","height":24,"width":32};